import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { DirectTreasuryOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { DirectTreasuryAssetProvider } from '../../../../../contexts/products/DirectTreasury';
import { ItemDetails } from '../Details';

import { DirectTreasuryListItemDesktop } from './desktop';
import { DirectTreasuryListItemMobile } from './mobile';
import { DirectTreasuryListItemTablet } from './tablet';

export namespace DirectTreasuryListItemTypes {
  export interface Props {
    offer: DirectTreasuryOfferEntityNormalized;
  }
}

export const DirectTreasuryListItem: React.FC<DirectTreasuryListItemTypes.Props> = ({ offer }) => {
  const directTreasuryListItem = useBreakpointValue({
    base: <DirectTreasuryListItemMobile offer={offer} />,
    sm: <DirectTreasuryListItemTablet offer={offer} />,
    lg: <DirectTreasuryListItemDesktop offer={offer} />,
  });

  return (
    <DirectTreasuryAssetProvider>
      <ItemDetails />
      {directTreasuryListItem}
    </DirectTreasuryAssetProvider>
  );
};
